import type {DisplayType} from '@Panels/poster-publishing-options-panel/poster-publishing-options-panel.types';
import type {Dispatch, SetStateAction} from 'react';

export interface PublishingDigitalSignageListProps {
  displayType: DisplayType;
  setTopShadow: Dispatch<SetStateAction<boolean>>;
}

export enum DigitalSignageOption {
  SCREENCLOUD = 'SCREENCLOUD',
  SIGNAGE_LIVE = 'SIGNAGE_LIVE',
  YODECK = 'YODECK',
}
